import PlayersList from './PlayersList';

export default PlayersList;
